export const workspaceKey_ManagerPathway = 'workspace__pathway-editor';
export const WorkspaceConfig_ManagerPathway = {
    name: workspaceKey_ManagerPathway,
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            {
                name: 'LeftPanel', key: 'selector', visible: true, factor: 2.6 / 5, min: 600,
                data: {}
            },
            {
                name: 'RightPanel', key: 'presenter', visible: true, factor: 2.4 / 5, min: 500,
                data: {}
            },
        ]
    }
};
//# sourceMappingURL=workspace-config.js.map